// Helpers to detect blocked browser shortcuts (devtools / view-source)
const DEVTOOLS_SHIFT_KEYS = ['i', 'I', 'j', 'J', 'c', 'C'];

const isF12 = (e) => e.key === 'F12';

const isViewSource = (e) =>
  (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (e.key === 'u' || e.key === 'U');

const isDevtoolsCombo = (e) =>
  (e.ctrlKey || e.metaKey) && e.shiftKey && DEVTOOLS_SHIFT_KEYS.includes(e.key);

export const shouldBlockKey = (e) => isF12(e) || isViewSource(e) || isDevtoolsCombo(e);
